import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useSelector } from "react-redux";
import LottieAnimation from "../../Animations/LottieAnimation";
import { ToFirstCapital } from "../../Utils/helpers";
import "./settingsMain.css";

const SECTION_MAP = {
  geo: {
    label: "Location & Geography",
    keys: ["country", "locality", "coming_soon_cities"],
    colorClass: "ic-geo",
    tagClass: "tag-geo",
    tagLabel: "Location",
  },
  user: {
    label: "Users & Access",
    keys: ["access_list"],
    colorClass: "ic-user",
    tagClass: "tag-user",
    tagLabel: "Access",
  },
  user_queries: {
    label: "User Queries",
    keys: ["user_query_project"],
    colorClass: "ic-user",
    tagClass: "tag-user",
    tagLabel: "Queries",
  },
  finance: {
    label: "Finance & Payments",
    keys: ["currency", "referral_Commission", "Finance_Partners", "agent_margin_details", "corporate_rental_discount"],
    colorClass: "ic-finance",
    tagClass: "tag-finance",
    tagLabel: "Finance",
  },
  config: {
    label: "Platform Config",
    keys: [
      "ranking",
      "reels",
      "resale_ranking",
      "categories",
      // "categories_resale",
      "collections",
      // "collections_resale",
      "amenities",
      // "amenities_resale",
      "furnishing",
      "appointment_config",
      "config",
      "pages",
      "oora",
      "resale_plan",
      "vr_shoot_rental_plan",
      "agent_profit_ranges",
      "featured_business_property",
    ],
    colorClass: "ic-config",
    tagClass: "tag-config",
    tagLabel: "Config",
  },
  content: {
    label: "Content & Media",
    keys: [
      "brands",
      "fa_brands",
      "surrounding_Industries",
      "faq",
      "email_Templates",
      "email",
      "notification",
      "rating_review_panel",
      "home_banner",
      "resale_vibe",
      "home_category",
      "home_vr",
      "project_report",
    ],
    colorClass: "ic-content",
    tagClass: "tag-content",
    tagLabel: "Content",
  },
  transport: {
    label: "Transport",
    keys: ["cab_Settings", "cabServiceProvider"],
    colorClass: "ic-transport",
    tagClass: "tag-transport",
    tagLabel: "Transport",
  },
  blog: {
    label: "Blog & Articles",
    keys: ["blog"],
    colorClass: "ic-blog",
    tagClass: "tag-blog",
    tagLabel: "Blog",
  },
  legal: {
    label: "Legal & Policies",
    keys: ["cancellation_Policies"],
    colorClass: "ic-legal",
    tagClass: "tag-legal",
    tagLabel: "Legal",
  },
};

const ICONS = {
  country: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="1.8" strokeLinecap="round">
      <circle cx="12" cy="12" r="9" /><path d="M12 3c-3 4-3 14 0 18M3 12h18M4.5 7.5c4 1.5 11 1.5 15 0M4.5 16.5c4-1.5 11-1.5 15 0" />
    </svg>
  ),
  locality: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="1.8" strokeLinecap="round">
      <path d="M12 21s-7-6.5-7-11a7 7 0 1 1 14 0c0 4.5-7 11-7 11z" /><circle cx="12" cy="10" r="2" />
    </svg>
  ),
  coming_soon_cities: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="1.8" strokeLinecap="round">
      <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" />
    </svg>
  ),
  access_list: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#534AB7" strokeWidth="1.8" strokeLinecap="round">
      <rect x="3" y="11" width="18" height="10" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  ),
  currency: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="1.8" strokeLinecap="round">
      <circle cx="12" cy="12" r="9" /><path d="M14.5 8H10a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H9.5M12 6v2M12 16v2" />
    </svg>
  ),
  agent_margin_details: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="1.8" strokeLinecap="round">
      <path d="M3 3v18h18" />
      <path d="M7 12l4-3 4 3 4-5" />
      <circle cx="7" cy="12" r="1.5" fill="#3B6D11" />
      <circle cx="11" cy="9" r="1.5" fill="#3B6D11" />
      <circle cx="15" cy="12" r="1.5" fill="#3B6D11" />
      <circle cx="19" cy="7" r="1.5" fill="#3B6D11" />
    </svg>
  ),
  referral_Commission: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="1.8" strokeLinecap="round">
      <path d="M17 1l4 4-4 4M7 23l-4-4 4-4M21 5H9a4 4 0 0 0-4 4v2M3 19h12a4 4 0 0 0 4-4v-2" />
    </svg>
  ),
  featured_business_property: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      <path d="M12 11v4M10 13h4" />
    </svg>
  ),
  project_report: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.8" strokeLinecap="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
      <path d="M12 12v4M10 14h4" />
    </svg>
  ),
  Finance_Partners: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="1.8" strokeLinecap="round">
      <rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  home_banner: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.8" strokeLinecap="round">
      <rect x="3" y="3" width="18" height="12" rx="2" />
      <path d="M3 9h18M7 15v4M17 15v4M5 19h14" />
    </svg>
  ),
  corporate_rental_discount: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="1.8" strokeLinecap="round">
      <rect x="2" y="6" width="20" height="12" rx="2" />
      <circle cx="12" cy="12" r="2.5" />
      <path d="M6 6v.01M18 6v.01M6 18v-.01M18 18v-.01" />
    </svg>
  ),
  resale_vibe: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.8" strokeLinecap="round">
      <rect x="3" y="3" width="18" height="12" rx="2" />
      <path d="M3 9h18M7 15v4M17 15v4M5 19h14" />
    </svg>
  ),
  home_category: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.8" strokeLinecap="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  user_query_project: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#534AB7" strokeWidth="1.8" strokeLinecap="round">
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.35-4.35" />
      <path d="M9 22l9-7 9 7" transform="scale(0.5) translate(2, 8)" />
    </svg>
  ),
  home_vr: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <path d="M2 8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8z" />
      <circle cx="8" cy="12" r="2" />
      <circle cx="16" cy="12" r="2" />
      <path d="M10 12h4" />
    </svg>
  ),
  config: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
    </svg>
  ),
  categories: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  ),
  // categories_resale: (
  //   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
  //     <rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" />
  //   </svg>
  // ),
  collections: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <path d="M4 4h16v4H4zM4 12h16v4H4zM4 20h16" />
    </svg>
  ),
  // collections_resale: (
  //   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
  //     <path d="M4 4h16v4H4zM4 12h16v4H4zM4 20h16" />
  //   </svg>
  // ),
  // amenities_resale: (
  //   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
  //     <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
  //   </svg>
  // ),
  amenities: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
    </svg>
  ),
  furnishing: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <rect x="2" y="7" width="20" height="10" rx="2" /><path d="M6 17v3M18 17v3M2 12h20" />
    </svg>
  ),
  appointment_config: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <rect x="3" y="4" width="18" height="17" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  ),
  ranking: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <path d="M18 20V10M12 20V4M6 20v-6" />
    </svg>
  ),
  reels: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <path d="M18 20V10M12 20V4M6 20v-6" />
    </svg>
  ),
  resale_ranking: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <path d="M18 20V10M12 20V4M6 20v-6" />
    </svg>
  ),
  blog: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1a6b4a" strokeWidth="1.8" strokeLinecap="round">
      <path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
    </svg>
  ),
  pages: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
    </svg>
  ),
  oora: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="4" />
    </svg>
  ),
  resale_plan: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="4" />
    </svg>
  ),
  vr_shoot_rental_plan: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <path d="M2 8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8z" />
      <circle cx="8" cy="12" r="2" />
      <circle cx="16" cy="12" r="2" />
      <path d="M10 12h4" />
    </svg>
  ),
  agent_profit_ranges: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5f5e5a" strokeWidth="1.8" strokeLinecap="round">
      <path d="M3 3v18h18" /><path d="M7 16l4-4 4 4 4-6" />
    </svg>
  ),
  brands: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.8" strokeLinecap="round">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><circle cx="7" cy="7" r="1.5" fill="#993556" />
    </svg>
  ),
  fa_brands: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.8" strokeLinecap="round">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  ),
  surrounding_Industries: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.8" strokeLinecap="round">
      <rect x="2" y="7" width="6" height="13" /><rect x="9" y="3" width="6" height="17" /><rect x="16" y="10" width="6" height="10" /><path d="M2 21h20" />
    </svg>
  ),
  faq: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.8" strokeLinecap="round">
      <circle cx="12" cy="12" r="9" /><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3M12 17h.01" />
    </svg>
  ),
  email_Templates: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.8" strokeLinecap="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><path d="M22 6l-10 7L2 6" />
    </svg>
  ),
  email: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.8" strokeLinecap="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><path d="M22 6l-10 7L2 6" />
    </svg>
  ),
  notification: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.8" strokeLinecap="round">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  ),
  rating_review_panel: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.8" strokeLinecap="round">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  ),
  cab_Settings: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" strokeWidth="1.8" strokeLinecap="round">
      <path d="M5 17H3v-5l3-5h12l3 5v5h-2M5 17a2 2 0 1 0 4 0 2 2 0 0 0-4 0M15 17a2 2 0 1 0 4 0 2 2 0 0 0-4 0" /><path d="M5 12h14" />
    </svg>
  ),
  cabServiceProvider: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" strokeWidth="1.8" strokeLinecap="round">
      <circle cx="12" cy="12" r="9" /><path d="M12 8v4l3 3" />
    </svg>
  ),
  cancellation_Policies: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#854F0B" strokeWidth="1.8" strokeLinecap="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6M9 15l2 2 4-4" />
    </svg>
  ),
};

const DEFAULT_ICON = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#888780" strokeWidth="1.8" strokeLinecap="round">
    <circle cx="12" cy="12" r="9" /><path d="M12 8v4M12 16h.01" />
  </svg>
);

const getDisplayName = (comp) => {
  if (comp === "fa_brands") return "Featured / Associated Brands";
  if (comp === "vr_shoot_rental_plan") return "VR Shoot Rental Plan";
  if (comp === "corporate_rental_discount") return "Corporate Rental Discount";
  if (comp === "user_query_project") return "User Query Projects";
  return ToFirstCapital(comp).replace(/[-_]/g, " ");
};

// const getSectionForKey = (key) => {
//   for (const [, sec] of Object.entries(SECTION_MAP)) {
//     if (sec.keys.includes(key)) return sec;
//   }
//   return null;
// };

const SettingsMain = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const currentRole = useSelector((state) => state?.admin?.admin?.data?.role);
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes("add");

  const componentsList = [
    "country", "locality", "ranking", "reels", "resale_ranking", "categories", "collections", "agent_margin_details",
    "currency", "amenities", "furnishing", "appointment_config", "config", "featured_business_property",
    "pages", "oora", "resale_plan", "vr_shoot_rental_plan", "brands", "referral_Commission", "surrounding_Industries",
    "faq", "cab_Settings", "cabServiceProvider", "Finance_Partners", "blog", "resale_vibe", "project_report",
    "cancellation_Policies", "fa_brands", "coming_soon_cities", "rating_review_panel", "home_banner", "home_category", "home_vr",
    "corporate_rental_discount", "user_query_project",
  ];

  const permissionComponents = [];
  if (canAdd) {
    permissionComponents.push("notification", "email_Templates", "email", "agent_profit_ranges");
  }

  const superAdminExclusive = currentRole === "super_admin" ? ["access_list"] : [];
  const finalComponentsList = [...superAdminExclusive, ...componentsList, ...permissionComponents];

  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [activeFilter, setActiveFilter] = useState("all");

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleClick = (comp) => {
    window.location.href = `/${comp}`;
  };

  const grouped = Object.entries(SECTION_MAP).map(([id, sec]) => {
    const items = sec.keys.filter(
      (k) =>
        finalComponentsList.includes(k) &&
        getDisplayName(k).toLowerCase().includes(search.toLowerCase())
    );
    return { id, ...sec, items };
  }).filter((s) => s.items.length > 0);

  const filteredSections =
    activeFilter === "all" ? grouped : grouped.filter((s) => s.id === activeFilter);

  const totalVisible = filteredSections.reduce((acc, s) => acc + s.items.length, 0);

  const allFilters = [
    { id: "all", label: "All" },
    ...grouped.map((s) => ({ id: s.id, label: s.label })),
  ];

  return (
    <div className="settings-main">
      {loading ? (
        <LottieAnimation />
      ) : (
        <MainLayout>
          <section className="settings-wrapper">
            <div className="settings-topbar">
              <div>
                <h1 className="settings-header">Settings</h1>
                <p className="settings-subheader">Manage all platform configurations</p>
              </div>
              <div className="settings-search-wrap">
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                  <circle cx="6.5" cy="6.5" r="5" stroke="#b4b2a9" strokeWidth="1.5" />
                  <path d="M10.5 10.5L14 14" stroke="#b4b2a9" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
                <input
                  type="text"
                  placeholder="Search settings..."
                  value={search}
                  onChange={(e) => { setSearch(e.target.value); setActiveFilter("all"); }}
                />
              </div>
            </div>

            <div className="settings-filter-bar">
              {allFilters.map((f) => (
                <button
                  key={f.id}
                  className={`settings-filter-pill${activeFilter === f.id ? " active" : ""}`}
                  onClick={() => setActiveFilter(f.id)}
                >
                  {f.label}
                  {f.id === "all" && (
                    <span className="settings-count-badge">{totalVisible}</span>
                  )}
                </button>
              ))}
            </div>

            {filteredSections.length === 0 ? (
              <div className="settings-empty">No settings found for "{search}"</div>
            ) : (
              filteredSections.map((section) => (
                <div key={section.id} className="settings-section">
                  <div className="settings-section-title-row">
                    <span className="settings-section-title">{section.label}</span>
                    <span className="settings-section-count">{section.items.length}</span>
                  </div>
                  <div className="cards-container">
                    {section.items.map((comp) => (
                      <div
                        key={comp}
                        className="card-item"
                        onClick={() => handleClick(comp)}
                        role="button"
                        tabIndex={0}
                        onKeyPress={(e) => {
                          if (e.key === "Enter" || e.key === " ") handleClick(comp);
                        }}
                      >
                        <div className="card-item-top">
                          <div className={`card-icon-wrap ${section.colorClass}`}>
                            {ICONS[comp] || DEFAULT_ICON}
                          </div>
                          <div className="card-arrow">
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                              <path d="M2 8L8 2M8 2H4M8 2v4" stroke="#5f5e5a" strokeWidth="1.4" strokeLinecap="round" />
                            </svg>
                          </div>
                        </div>
                        <div className="card-item-name">{getDisplayName(comp)}</div>
                        <span className={`card-item-tag ${section.tagClass}`}>{section.tagLabel}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            )}
          </section>
        </MainLayout>
      )}
    </div>
  );
};

export default SettingsMain;